module.exports = __webpack_public_path__ + "static/prairie-sky-cf06a89d7c9357a4db4b709b29f9c056.jpg";